import { render } from "./moreWidth.vue?vue&type=template&id=53596167&scoped=true"
const script = {}

import "./moreWidth.vue?vue&type=style&index=0&id=53596167&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4e85b6a685c6792d169835830baf5532/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53596167"]])

export default __exports__